import React, { useState } from 'react';
import Footer from '../Footer/Footer';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
    option: '',
  });
  const [submissionStatus, setSubmissionStatus] = useState(null);
  const [submissionError, setSubmissionError] = useState('');
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    // Clear errors for the current field as the user types
    if (errors[e.target.name]) {
      setErrors({ ...errors, [e.target.name]: '' });
    }
  };

  const validateForm = () => {
    let valid = true;
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = 'Name is required';
      valid = false;
    }
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
      valid = false;
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Invalid email format';
      valid = false;
    }
    if (!formData.subject.trim()) {
      newErrors.subject = 'Subject is required';
      valid = false;
    }
    if (!formData.message.trim()) {
      newErrors.message = 'Message is required';
      valid = false;
    }
    if (!formData.option) {
      newErrors.option = 'Please select an inquiry type';
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setSubmissionStatus('submitting');
    setSubmissionError('');

    try {
      const apiUrl = '/api/send-email';
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setSubmissionStatus('success');
        setFormData({
          name: '',
          email: '',
          subject: '',
          message: '',
          option: '',
        });
      } else {
        const errorData = await response.json();
        setSubmissionStatus('error');
        setSubmissionError(errorData.message || 'Error sending email.');
      }
    } catch (error) {
      console.error('Error:', error);
      setSubmissionStatus('error');
      setSubmissionError('An unexpected error occurred.');
    }
  };

  return (
    <div className="contact-page">
      <div className="contact-container">
        <header className="contact-header">
          <h2>Get in Touch</h2>
          <p>
            Whether you have a question, a project idea, or just want to say hello, we'd love to hear from you.
          </p>
        </header>

        <form onSubmit={handleSubmit} className="contact-form">
          {submissionStatus === 'success' && (
            <p className="submission-message success">
              Thank you for your message! We'll be in touch soon.
            </p>
          )}
          {submissionStatus === 'error' && (
            <p className="submission-message error">
              Error: {submissionError}
            </p>
          )}

          <div className="form-row">
            <div className="form-group half">
              <label htmlFor="name">Name:</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                disabled={submissionStatus === 'submitting'}
              />
              {errors.name && <p className="input-error">{errors.name}</p>}
            </div>
            <div className="form-group half">
              <label htmlFor="email">Email:</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                disabled={submissionStatus === 'submitting'}
              />
              {errors.email && <p className="input-error">{errors.email}</p>}
            </div>
          </div>

          <div className="form-row">
            <div className="form-group half">
              <label htmlFor="option">Inquiry Type:</label>
              <select
                id="option"
                name="option"
                value={formData.option}
                onChange={handleChange}
                disabled={submissionStatus === 'submitting'}
              >
                <option value="">-- Please select an option --</option>
                <option value="Sales">Sales & Quotes</option>
                <option value="Support">Support</option>
                <option value="General Inquiry">General Inquiry</option>
                <option value="Feedback">Feedback</option>
                <option value="Other">Other</option>
              </select>
              {errors.option && <p className="input-error">{errors.option}</p>}
            </div>
            <div className="form-group half">
              <label htmlFor="subject">Subject:</label>
              <input
                type="text"
                id="subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                disabled={submissionStatus === 'submitting'}
              />
              {errors.subject && <p className="input-error">{errors.subject}</p>}
            </div>
          </div>

          <div className="form-group full">
            <label htmlFor="message">Message:</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              disabled={submissionStatus === 'submitting'}
            ></textarea>
            {errors.message && <p className="input-error">{errors.message}</p>}
          </div>

          <button
            className="cta-button"
            type="submit"
            disabled={submissionStatus === 'submitting'}
          >
            {submissionStatus === 'submitting' ? 'Sending...' : 'Send Message'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Contact;